import { BsTelegram } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { BsLinkedin } from "react-icons/bs";

function HeaderSocial() {
  return (
    <div className="header__socials">
      <a target="_blank" href="https://github.com/akuna444" rel="noreferrer">
        <FaGithub />
      </a>
      <a
        target="_blank"
        href="https://linkedin.com/in/aklil-solomon"
        rel="noreferrer"
      >
        <BsLinkedin />
      </a>
      <a target="_blank" href="https://t.me/akuna444" rel="noreferrer">
        <BsTelegram />
      </a>
    </div>
  );
}

export default HeaderSocial;
